import { type PropsWithChildren } from 'react';

export const Icon = ({ children }: PropsWithChildren) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>{children}</>
);

Icon['displayName'] = 'MeterBarChart.Icon';
